export default "__VITE_PUBLIC_ASSET__d51cb15e__"